import { LOAD_STATE } from '../constants/redux.constants';

/**
 * @deprecated
 * TODO: #594 Use axios module
 */
export const isDataLoading = loadState => (
    LOAD_STATE.LOADING === loadState
);
